/*
 *   File : success-modal.js
 *   Author : https://evoqins.com
 *   Description : success modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { PrimaryButton } from "../Buttons";

/* ---------- Overlay Component ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Delete Modal Component ---------- */
export default function SuccessModal({
  open = false,
  message,
  title,
  onConfirm,
}) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onConfirm} />

      {/* Modal Box */}
      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle e-modal-portal rounded-28 shadow p-0"
        style={{
          zIndex: 1055,
          width: "600px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="d-flex e-bg-blur-20 flex-column row-gap-3 justify-content-center bg-white bg-opacity-80 align-items-center p-24"
        >
          <img
            src={
              require("../../Assets/Images/Components/Modal/success.svg")
                .default
            }
            alt="Success Image"
          />
          {/* Message */}

          <h5 className="fw-500 fs-14 text-start lh-24 text-eerie-black mb-0">
            {title}
          </h5>
          <div className="row w-100">
            <div className="col-lg-8 offset-lg-2">
              <h3 className="fw-400 fs-14 text-center lh-24 text-eerie-black">
                {message || "Are you sure you want to delete this item?"}
              </h3>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="row w-100">
            <div className="offset-3 col-6">
              <PrimaryButton
                name="Ok"
                ClassName="rounded-pill bg-oxford-blue lh-24 py-3 text-white w-100 fs-16 fw-500"
                onPress={onConfirm}
              />
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}
